module.exports = __webpack_public_path__ + "static/haveWky.9a58add7.png";